import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-logo">✨ FashionAI</span>
          <p className="footer-tagline">Turn words into wearable art — made just for you.</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} FashionAI — AI-powered custom merchandise. Built with ✨ and{' '}
          <a href="https://react.dev" target="_blank" rel="noopener noreferrer">React</a>.
        </p>
        <p className="footer-made">
          Made with <span style={{ color: '#f43f5e' }}>♥</span> using{' '}
          <a href="https://fashionai-24n.pages.dev" target="_blank" rel="noopener noreferrer">FashionAI</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
